export const getConsoleList = state => state.console.list;
